import { createContext, useContext } from 'react';

export interface PortalDisplayData {
	title?: string;
	presentation?: string;
	coverImageUrl?: string;
	imageAlt?: string;
	textsNotFound: boolean;
	campaigns: number;
	donors: number;
	collected: number;
	hideCollected: boolean;
	logoUrl?: string;
	hideAppLink: boolean;
	color: string;
	locale: string;
	sliderItems?: {
		imageUrl?: string;
		quote: string;
		authorName: string;
		imageAlt?: string;
	}[];
	faqItems?: {
		question: string;
		answer: string;
	}[];
}

const PortalDisplayContext = createContext<PortalDisplayData | null>(null);

export function PortalDisplayProvider({ data, children }: { data: PortalDisplayData; children: React.ReactNode }) {
	return <PortalDisplayContext.Provider value={data}>{children}</PortalDisplayContext.Provider>;
}

export function usePortalDisplayContext() {
	return useContext(PortalDisplayContext);
}
